import { api } from "@/api"

type RetrieveSelfMerchantGroupAdminResponse = {
  id: string
  email: string
  hasPassword: boolean
}

export const retrieveSelfMerchantGroupAdmin = async () => {
  const { body } =
    await api.get<RetrieveSelfMerchantGroupAdminResponse>(
      "/merchant-group/merchant-group-admins/self/",
      { isMerchantGroup: true }
    )
  return body
}
